import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormInputTextarea } from '../../common/formInputs/FormInputTextarea';
import { AfterSaleCreateFormFlowStyles, AfterSaleCreateFormStyles } from '../../common/AfterSale/AfterSaleCreate.styles';
import { CenteredDivTitle } from '../../common/components/CenteredPageTitle.styles';
import { addNewModification } from '../../features/afterSale/afterSaleActions';

const schema = yup.object({
  note: yup.string().required('Il campo è obbligatorio'),
});

export function ModifyData() {
  const { quoteId } = useParams();
  const navigate = useNavigate();
  const {
    register, formState: { errors, touchedFields }, trigger, watch,
  } = useForm({
    mode: 'all',
    resolver: yupResolver(schema),
    defaultValues: {
      note: '',
    },
  });

  const formData = watch();

  const submitData = async (formData) => {
    const triggerValidation = await trigger(['note', 'suspension_date', 'riactivation_date']);
    if (!triggerValidation) {
      return;
    }

    addNewModification(quoteId, formData, navigate);
  };

  const isValid = (name) => {
    if (errors[name]?.message !== undefined) {
      return false;
    }

    if (touchedFields[name] === undefined) {
      return false;
    }
    return true;
  };

  return (
    <AfterSaleCreateFormFlowStyles>
      <AfterSaleCreateFormStyles>
        <CenteredDivTitle className="d-flex align-items-center justify-content-center gap-3 mt-3">
          <div className="after-sale-title divider">
            <h2 className="text-center">Modifica dati non tariffari</h2>
          </div>
        </CenteredDivTitle>
        <div className="form-container-after-sale">
          <FormInputTextarea
            placeholder="Note"
            label="Nota"
            registration={register('note')}
            rows="3"
            error={errors.note?.message}
            valid={isValid('note')}
          />

        </div>
        <div className="mt-3">
          <div className="d-flex justify-content-between">
            <button
              className="btn btn-questionnaire "
              onClick={() => submitData(formData)}
            >
              Continua
            </button>
          </div>
        </div>
      </AfterSaleCreateFormStyles>
    </AfterSaleCreateFormFlowStyles>
  );
}
